import React, { FC } from 'react';
import { Text, TextTypography as TYPOGRAPHY } from 'wix-ui-tpa';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import { st, classes } from './EmptyState.st.css';
import { DataHooks } from './consts';

export type EmptyStateProps = {};

export const EmptyState: FC<EmptyStateProps> = () => {
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();

  return (
    <div
      data-hook={DataHooks.WRAPPER}
      className={st(classes.root, { isMobile })}
    >
      <div className={classes.container}>
        <Text
          data-hook={DataHooks.CONTENT}
          typography={TYPOGRAPHY.smallTitle}
          className={classes.content}
        >
          {t('empty-state.text')}
        </Text>
      </div>
    </div>
  );
};
